import {str} from 'evite';

const INVALID_INVITATION_EMAILS = [
  'abuse@evite.com',
  'postmaster@evite.com',
  'hostmaster@evite.com',
  'webmaster@evite.com',
];
export const validateName = (nameOrContact) => {
  const contact = typeof nameOrContact === 'object' ? nameOrContact : null;
  let name = contact ? contact.name : nameOrContact;
  name = str(name).trim();

  if (!name && contact && contact.phone && contact.invite_method === 'sms') {
    return {
      valid: false,
      message: 'Guest name is required for contact(s) with phone number(s)',
    };
  }
  if (!name) {
    return {valid: false, message: 'Guest name is required'};
  }
  if (name.length > 80) {
    return {valid: false, message: 'Name max length is 80'};
  }
  return {valid: true};
};

// matching validation logic in /typhoon/assets/js/common/utils.js
export const validateEmail = (email, allowEmpty) => {
  const MAX_EMAIL_LENGTH = 254;

  email = str(email).trim();
  email = email.replace(/^[\s(<{[]+/, '');
  email = email.replace(/[\s)>}\]]+$/, '');

  if (!email && allowEmpty) {
    return {valid: true, value: ''};
  }

  if (!email && !allowEmpty) {
    return {valid: false, message: 'Email required'};
  }

  if (INVALID_INVITATION_EMAILS.includes(email)) {
    return {valid: false, message: 'Invalid email'};
  }

  if (email.length > MAX_EMAIL_LENGTH) {
    return {valid: false, message: `Email max length is ${MAX_EMAIL_LENGTH}`};
  }

  // to match backEnd validation
  const regex = /(^\s*[a-zA-Z0-9."!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9-.]+\s*$)/gm;
  const isValidFormat = regex.exec(email);

  if (!isValidFormat) {
    return {valid: false, message: 'Invalid email address'};
  }

  return {valid: true, value: email};
};

// matching validation logic in /typhoon/assets/js/common/utils.js
export function validatePhone(phone) {
  phone = str(phone).trim();

  if (phone && phone.indexOf('@') === -1) {
    const allNonDigits = /\D+/g;
    phone = phone.replace(allNonDigits, '');

    if (phone.length === 10) {
      phone = `1${phone}`;
    }

    if (isPhoneInCountry(phone, 'US') || isPhoneInCountry(phone, 'CA')) {
      return {valid: true, value: phone};
    }
  }

  return {
    valid: false,
    message: 'Please enter a valid US / CA phone number',
  };
}

function isPhoneInCountry(phone, country) {
  const firstChar = phone.charAt(0);

  if (['US', 'CA'].includes(country)) {
    return phone.length === 11 && firstChar === '1';
  }

  return false;
}
